export default {
    organization: 'Grupo de trabajo',
    project: 'Proyecto',
    dataset: 'Fuente',
    report: 'Informe',
    visualization: 'Visualización',
    download: 'Descargar zip',
    events: 'Eventos',
    processing: 'Procesando...',

    date: 'Fecha',
    createdAt: 'Creado',
    updateDate: 'Última actualización',
    projectCount: 'Proyectos contenidos',
    datasetCount: 'Fuentes contenidas',
    deleteDate: 'Eliminado',
    startAt: 'Inicio',
    endAt: 'Final',
    seenAt: 'Visto',
    content: 'Contenido',

    code: 'Código',
    title: 'Título',
    name: 'Nombre',
    description: 'Descripción',
    status: 'Estado',
    model: 'Modelo',
    email: 'Correo electrónico',
    amount: 'Cantidad',
    actions: 'Acciones',
    type: 'Tipo',
    file: 'Fichero',
    characters: 'Caracteres',

    owner: 'Propietario',
    sortBy: 'Ordenar por',
    sortDirection: 'Dirección',
    ascending: 'Ascendente',
    descending: 'Descendente',

    readOnly: 'Solo lectura',
    archived: 'Archivados',
    optional: 'Opcional',
    uploadData: 'Subir fichero',
    comingSoon: 'Próximamente',

    account: 'Cuenta',
    profile: 'Perfil',
    apis: 'Token API',
    signout: 'Cerrar sesión',

    back: 'Atrás',
    forward: 'Adelante',

    zoomIn: 'Acercar',
    zoomOut: 'Alejar',

    info: 'Información',
    updateData: 'Actualizar datos',
    replaceData: 'Reemplazar datos',
    dataOptions: 'Opciones de datos',

    filters: 'Filtros',
    sorting: 'Ordenación',
}
